import { useMutation, useQueryClient } from "@tanstack/react-query";
import { 
    deleteSelectedQuestionsFromSurveyBankQuestionBank,
} from ".";

export function useDeleteQuestionsFromSurveyBankQuestionBank(){
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["deleteSelectedQuestionsFromSurveyBankQuestionBank"],
        mutationFn: async (ids: string[]) => {
            const res = await deleteSelectedQuestionsFromSurveyBankQuestionBank(ids);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["surveyBank"] });
        }
    });
}